import { SystemProps, Text } from "flicket-ui";
import { parseRichText } from "~lib/helpers/hasRichTextContent";
import { pick } from "@styled-system/props";
import { hasRichTextContent } from "../../../../../lib/helpers/hasRichTextContent";

export default function RichTextPreview({
  value,
  lines = 3,
  variant = "regular",
  ...props
}: {
  value: string;
  lines?: number;
  variant?: "regular" | "small";
} & SystemProps) {
  if (!hasRichTextContent(value)) {
    return null;
  }

  const richText = parseRichText(value);

  const text = richText
    ?.map((item) => item?.children?.[0]?.text ?? "")
    .join(" ");
  return (
    <>
      <Text
        variant={variant}
        {...pick(props)}
        css={`
          -webkit-box-orient: vertical;
          display: -webkit-box;
          -webkit-line-clamp: ${lines};
          overflow: hidden;
        `}
      >
        {text}
      </Text>
      <Text variant="small" textDecoration="underline">
        more info
      </Text>
    </>
  );
}
